import React from 'react';

import CollapsedContentHeader from '../CollapsedContentHeader';

export default function CompletedContent(props) {
  return (
    <div className="PathContentCollapsed">
      <CollapsedContentHeader {...props} />
      <div className="PathContentCollapsed-step" />
    </div>
  );
}
